import { render, staticRenderFns } from "./noContent.vue?vue&type=template&id=0750f1bd&scoped=true"
import script from "./noContent.ts?vue&type=script&lang=ts&external"
export * from "./noContent.ts?vue&type=script&lang=ts&external"
import style0 from "./noContent.vue?vue&type=style&index=0&id=0750f1bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0750f1bd",
  null
  
)

export default component.exports